module.exports = __webpack_public_path__ + "static/media/footwear-2.b43674cd.jpg";